export default __webpack_public_path__ + "static/media/vip-icon-home-mobile.f4daa4f1.webp";